import api from "./api";
import { orderTypes, orderDetailsStatus } from "./lynkco-constants";

export const checkIfAnyFirmOrder = async () => {
  const { obj } = await api.order.list(null, { displayLength: 100, displayStart: 0 });
  const firmOrders = obj?.data.filter(order => isConfirmedFirmOrder(order));

  return firmOrders;
};

const isConfirmedFirmOrder = order => {
  const firmOrderType = order.subType === orderTypes?.monthToMonth || order.subType === orderTypes?.longTerm || order.subType === orderTypes?.buyACarCash || order.subType === orderTypes?.buyACarLoan;

  return firmOrderType && order.orderStatusCode === orderDetailsStatus?.bac_order_confirmed;
};
